import { render, staticRenderFns } from "./AmendmentsChangeBeneficialOwners.vue?vue&type=template&id=602f7a04&scoped=true&"
import script from "./AmendmentsChangeBeneficialOwners.vue?vue&type=script&lang=js&"
export * from "./AmendmentsChangeBeneficialOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f7a04",
  null
  
)

export default component.exports